// Scope decisions for the admin Learning panel, kept pure so they can be tested without
// a browser (same pattern as activity-autopanel / watchdog-policy).
//
// Background: a learned fact is either global platform knowledge (injectable for every
// tenant) or scoped to the one connection it was mined from. Candidates are born scoped;
// only a reviewer's deliberate act widens one to global. These helpers are the client half
// of that act, which is why the approve body is the part worth testing: it is what decides
// whether one customer's lesson starts appearing in another customer's runs.

/** "connection" | "global" -- what the badge shows. Unknown/missing reads as global,
 *  matching the server's derived label (NULL scope = global). */
export function scopeLabel(fact) {
  return (fact && fact.scope) === "connection" ? "connection" : "global";
}

/** Whether this fact is private to one connection (i.e. widening is even offered). */
export function isScoped(fact) {
  return scopeLabel(fact) === "connection";
}

/** The body to POST to /approve.
 *
 * `widenToGlobal` comes from an explicit checkbox, so omitting it keeps the candidate's
 * scope -- the default has to be "stay private", because the opposite default would widen
 * every private lesson at review time.
 *
 * A safety-flagged fact still carries its typed confirmation whether or not it is being
 * widened: widening must not become a way around the safety gate.
 */
export function buildApproveBody(fact, widenToGlobal) {
  const body = {};
  if (fact && fact.safety_flagged) body.typed_confirm = "PROMOTE";
  if (widenToGlobal) body.scope = "global";
  return body;
}
